export default __webpack_public_path__ + "static/media/zora-logo-white.fe696bfb.svg";